// @ts-nocheck

"use client";

import { Pause, Play, StopCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const TextToSpeech = ({ text }) => {
  const [isPaused, setIsPaused] = useState(false);
  const [utterance, setUtterance] = useState(null);

  useEffect(() => {
    const synth = window.speechSynthesis;
    const u = new SpeechSynthesisUtterance(text);
    u.pitch = "1.2";

    setUtterance(u);

    return () => {
      synth.cancel();
    };
  }, [text]);

  const handlePlay = () => {
    toast.success("Read-aloud playing");
    const synth = window.speechSynthesis;

    if (isPaused) {
      synth.resume();
    }

    synth.speak(utterance);

    setIsPaused(false);
  };

  const handlePause = () => {
    toast.success("Read-aloud paused");
    const synth = window.speechSynthesis;

    synth.pause();

    setIsPaused(true);
  };

  const handleStop = () => {
    toast.success("Read-aloud stopped");
    const synth = window.speechSynthesis;

    synth.cancel();

    setIsPaused(false);
  };

  return (
    <div>
      <button onClick={handlePlay}>
        <span className="sr-only">Play</span>
        <Play className="h-4 w-4" />
      </button>
      <button onClick={handlePause}>
        <span className="sr-only">Pause</span>
        <Pause className="h-4 w-4" />
      </button>
      <button onClick={handleStop}>
        <span className="sr-only">Stop</span>
        <StopCircle className="h-4 w-4" />
      </button>
    </div>
  );
};

export default TextToSpeech;
